import * as React from 'react';

const useBackdropController = () => {
  const [open, setOpen] = React.useState(false);

  const showOverlay = React.useCallback(() => {
    setOpen(true);
  }, [setOpen]);

  const hideOverlay = React.useCallback(() => {
    setOpen(false);
  }, [setOpen]);

  const showOverlayWhile = React.useCallback(
    (fn) =>
      async (...args) => {
        setOpen(true);
        try {
          const result = await fn(...args);
          setOpen(false);

          return result;
        } catch (e) {
          setOpen(false);
          throw e;
        }
      },
    [setOpen]
  );

  return [open, showOverlay, hideOverlay, showOverlayWhile];
};

export default useBackdropController;
